import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { LANGUAGES, LOCALES } from "translation";
import { DEFAULT_LOCALE } from "constants";

const initLanguages = () => {
  const resources = {};

  LOCALES.forEach((key) => (resources[key] = LANGUAGES[key].files));

  return resources;
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: initLanguages(),
    lng: DEFAULT_LOCALE,

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
